export function centroscustosInRequest(params = {}) {
  return {
    type: '@centrocusto/CENTROSCUSTOS_IN_REQUEST',
    payload: { params },
  };
}

export function findCentroCusto(idcentrocusto) {
  return {
    type: '@centrocusto/FIND_CENTROCUSTO',
    payload: { idcentrocusto },
  };
}

export function failedRequest() {
  return {
    type: '@centrocusto/FAILED_REQUEST',
  };
}

export function deleteCentroCusto(idcentrocusto, params) {
  return {
    type: '@centrocusto/DELETE_CENTROCUSTO',
    payload: { idcentrocusto, params },
  };
}

export function updateCentroCusto(centrocusto, params) {
  return {
    type: '@centrocusto/UPDATE_CENTROCUSTO',
    payload: { centrocusto, params },
  };
}

export function storeCentroCusto(centrocusto, params) {
  return {
    type: '@centrocusto/STORE_CENTROCUSTO',
    payload: { centrocusto, params },
  };
}

export function successInRequest(
  centroscustos,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@centrocusto/SUCCESS_IN_REQUEST',
    payload: { centroscustos, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(centrocusto) {
  return {
    type: '@centrocusto/SUCCESS_REQUEST',
    payload: { centrocusto },
  };
}

export function successRemove(params) {
  return {
    type: '@centrocusto/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@centrocusto/RECORD_FILTERING',
    payload: { params },
  };
}
